import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import video from './modules/video'
import toast from './modules/toast'
import preview from './modules/preview'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    video,
    toast,
    preview
  }
})

export default store
